'use client';

import { Button } from '@/components/ui/button';
import { ROUTES } from '@/constants/routes';
import { useAppContext } from '@/context/app-context';

type Props = {
    className?: string;
};

export const GetStartedBtn = ({ className }: Props) => {
    const { user, goToPage } = useAppContext();

    const handleClick = () => {
        goToPage(user ? ROUTES.Welcome : ROUTES.Login);
    };

    return (
        <Button className={className} onClick={handleClick}>
            Get Started
        </Button>
    );
};
